export default {"src":"/_next/static/media/cs.c8eecc3d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};